import React from 'react';
import { TextField, FormHelperText, Box } from '@material-ui/core';
import { ErrorMessage } from 'formik';

const CustomTextField = ({
  field,
  label,
  variant,
  rows,
  display,
  ...props
}) => {
  const { multiline } = props;
  return (
    <Box display={display}>
      <TextField
        {...field}
        {...props}
        value={field.value}
        name={field?.name}
        // onBlur={onBlur}
        multiline={multiline}
        rows={rows}
        label={label}
        variant={variant}
      />
      <ErrorMessage name={field?.name}>
        {(msg) => <FormHelperText error>{msg}</FormHelperText>}
      </ErrorMessage>
    </Box>
  );
};
export default CustomTextField;
